import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  MetaverseCustomTeam,
  MetaverseCustomAug,
  MetaverseCustomProject,
} from "../../../app-constants";

function Custommetaverse() {
  return (
    <section className="custom_metaverse p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Custom Collaboration for Metaverse App Development</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="custom_meta_box">
                  <div className="custom_meta_flex">
                    <div className="custom_meta_icon">
                      {MetaverseCustomTeam}
                    </div>
                    <div className="custom_meta_head">
                      <h5>
                        Dedicated Metaverse
                        <br /> Team
                      </h5>
                    </div>
                  </div>
                  <p>
                    Our specialized team, including project managers and tech
                    leads, works exclusively on your metaverse project, ensuring
                    seamless management and tailored development.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="custom_meta_box">
                  <div className="custom_meta_flex">
                    <div className="custom_meta_icon">{MetaverseCustomAug}</div>
                    <div className="custom_meta_head">
                      <h5>
                        Flexible Team
                        <br /> Augmentation
                      </h5>
                    </div>
                  </div>
                  <p>
                    Select top-notch metaverse experts to join your team
                    remotely, maintaining full control while leveraging our
                    technical expertise for advanced, immersive app development.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="custom_meta_box">
                  <div className="custom_meta_flex">
                    <div className="custom_meta_icon">
                      {MetaverseCustomProject}
                    </div>
                    <div className="custom_meta_head">
                      <h5>
                        Comprehensive Project
                        <br /> Delivery
                      </h5>
                    </div>
                  </div>
                  <p>
                    Partner with us for end-to-end metaverse app development. We
                    manage the entire project, incorporating your feedback to
                    deliver a fully customized, immersive experience.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Custommetaverse;
